/**
 * Tag — small inline pill label.
 * Atom purity: imports only react + tokens.
 */
import { CSSProperties, ReactNode } from 'react';
import { P, T } from '../../styles/tokens';

export interface TagProps {
  children: ReactNode;
  bg?: string;
  fg?: string;
  style?: CSSProperties;
}

export function Tag({ children, bg = P.cream, fg = P.ink, style }: TagProps) {
  // Prototype.jsx Tag (lines 239-246): cream-filled pill, 11px/600, fully rounded.
  const base: CSSProperties = {
    background: bg,
    color: fg,
    font: T.tag,
    padding: '3px 9px',
    borderRadius: 999,
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    whiteSpace: 'nowrap',
    ...style,
  };

  return <span style={base}>{children}</span>;
}
